import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

const dobleModalConfig = (title) => new Promise((resolve) => {
  Modal.confirm({
    title,
    icon: <ExclamationCircleOutlined />,
    onOk() {
      resolve(true);
    },
    onCancel() {
      resolve(false);
    },
    maskClosable: true
  })
});

export default dobleModalConfig;
